import React from 'react';
import PropTypes from 'prop-types';



import FormTemplate from '@/dialogs_common/FormTemplate';



import Site from './Site';
import queryString from 'query-string';

import Filters from '@/forms/filters_sites';
import useQuery from '@/pages/manage-sites/useQuery';
import classNames from 'classnames';
import EmptyState from '@/@communityshare/ui/EmptyState';
import { BuildingOffice2Icon } from '@heroicons/react/24/outline';

Form.propTypes = {
  data: PropTypes.shape({}),
  errors: PropTypes.shape({}),
  showErrors: PropTypes.bool,
  alert: PropTypes.node,
  onChange: PropTypes.func,
  onSubmit: PropTypes.func,
  onClose: PropTypes.func,
  network: PropTypes.shape({
    data: PropTypes.shape({
      name: PropTypes.string
    })
  }),
  router: PropTypes.shape({
    location: PropTypes.shape({
      search: PropTypes.string
    })
  })
};

Form.defaultProps = {
  // data: {},
  errors: {},
  showErrors: false,
  onChange: () => {}
};

export default function Form(props) {
  const {



    alert,

    onSubmit,
    onClose,
    network,
    router
  } = props;

  const search = queryString.parse(router.location.search);

  const sites = useQuery({
    search
  });

  return (
    <FormTemplate
      title="Add site to network"
      subtitle={
      <>
          Which site would you like to add to the
          network <span className="font-semibold text-cs-gray-700">{network.data.name}</span>?
        </>
      }
      onClose={onClose}
      alert={alert}
      body={
      <div className="space-y-6 pb-8">
          <Filters router={router} />
          <div className={classNames(
          'flex flex-col space-y-2',
          sites._isPreviousData && 'opacity-50'
        )}>
            {sites.data.length > 0 ? sites.data.map(function (site) {
            return (
              <Site
                key={site.id || site.cid}
                site={site}
                onClick={onSubmit} />);


          }) :
          <EmptyState
            icon={BuildingOffice2Icon}
            title="No matching sites found" />

          }
          </div>
        </div>
      }
      // footer={(
      //   <FormTemplateButtonFooter>
      //     <OutlineButton onClick={onClose}>
      //       Cancel
      //     </OutlineButton>
      //     <SolidButton onClick={onSubmit}>
      //       Create site
      //     </SolidButton>
      //   </FormTemplateButtonFooter>
      // )}
    />);

}